import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { IAppOnlyStore } from 'stores/AllStores';
import { UserEditableProperties } from 'stores/User';
import { scrollWindow } from 'events/scroll';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';

// Styles
const s = require('./UserProfile.css');

// Component
@inject('store')
@observer
export class UserProfileForm extends React.Component<IAppOnlyStore, {}> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        const { user } = this.props.store;

        return (
            <div className={s.editing}>
                <div className={s.group}>
                    <label>
                        <p>
                            <span>Name</span>
                        </p>
                        <input
                            type="text"
                            value={user.editedUser.name}
                            onChange={this.handleUserChange(UserEditableProperties.name)}
                        />
                    </label>

                    <label>
                        <p>
                            <span>Email address</span>
                        </p>
                        <input
                            type="text"
                            value={user.editedUser.email}
                            onChange={this.handleUserChange(UserEditableProperties.email)}
                        />
                    </label>
                </div>

                <div className={s.details}>
                    <div>
                        <button className="boxButton" onClick={this.handleSaveChanges}>Save changes</button>
                    </div>
                    <div>
                        <SavingIndicator
                            labels={{
                                saving: 'Saving changes...',
                                error: 'Could not save changes, try again',
                            }}
                            status={
                                user.userEditSavingError
                                    ? SavingIndicatorStatus.Error
                                    : user.userEditSaving
                                        ? SavingIndicatorStatus.Saving
                                        : SavingIndicatorStatus.None
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    @action private handleUserChange = (property: UserEditableProperties) => (e: React.FormEvent<HTMLInputElement>) => {
        this.props.store.user.editedUser[property] = e.currentTarget.value;
        this.props.store.user.editedUser.modified = true;
    };

    private handleSaveChanges = () => {
        this.props.store.user.saveUpdatedUser().then((success) => {
            scrollWindow.toY(0);
        });
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Profile/UserProfileForm.tsx